import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const Container = styled('div')<{ theme?: TTheme }>`
    display: grid;
    padding: 20px 24px;
    grid-template-columns: 1fr 1fr;
`
